export function parseXML(xmlString: string) {
  return new DOMParser().parseFromString(xmlString, 'application/xml');
}

export function xmlElementToString(xmlElement: Element | ChildNode): string | null {
  if (!xmlElement || !xmlElement.nodeType) {
    return null;
  }
  return new XMLSerializer().serializeToString(xmlElement);
}

export function extractXmlProps(element: Element | ChildNode) {
  const props: Record<string, string> = {};
  for (const node of Array.from(element.childNodes || [])) {
    props[node.nodeName] = node.textContent || '';
  }
  return props;
}

export function extractItemId(item: Element | ChildNode): string {
  const element = item as Element;
  const props = extractXmlProps(element);
  return props['CustomID'] || props['ID'] || '';
}

export const upsertChildren = (element: Element, props: { [key: string]: string }) => {
  for (const [key, value] of Object.entries(props)) {
    const existentChildren = element.getElementsByTagName(key);
    if (existentChildren.length === 1) {
      const existentChild = existentChildren[0];
      existentChild.textContent = value;
      continue;
    }

    if (existentChildren.length > 1) {
      console.error('More than one child with the same name', key, 'in', element);
      continue;
    }

    const child = document.createElementNS(null, key);
    child.textContent = value;
    element.appendChild(child);
  }
  return element;
};

export const removeChildren = (element: Element, props: string[]) => {
  for (const key of props) {
    const existentChildren = element.getElementsByTagName(key);
    for (let i = existentChildren.length - 1; i >= 0; i--) {
      existentChildren[i].remove();
    }
  }
  return element;
};

export function formatXML(xml: string, tab = '\t', nl = '\n') {
  let formatted = '',
    indent = '';
  const nodes = xml.slice(1, -1).split(/>\s*</);
  if (nodes[0][0] == '?') formatted += '<' + nodes.shift() + '>' + nl;
  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];
    if (node[0] == '/') indent = indent.slice(tab.length); // decrease indent
    formatted += indent + '<' + node + '>' + nl;
    if (node[0] != '/' && node[node.length - 1] != '/' && node.indexOf('</') == -1) indent += tab; // increase indent
  }
  return formatted;
}

export function getPropsFrom(xml: ChildNode | Element) {
  const currentXmlString = xmlElementToString(xml as Element);
  const currentXml = parseXML(currentXmlString || '');

  const root: Element = currentXml.documentElement;
  return extractXmlProps(root);
}
